import { render, staticRenderFns } from "./TaxAddEditModal.vue?vue&type=template&id=7494537b&"
import script from "./TaxAddEditModal.vue?vue&type=script&lang=js&"
export * from "./TaxAddEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports